"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDomRect = void 0;
var react_1 = require("react");
var useDomRect_1 = require("./tools/useDomRect");
var pick_1 = require("./tools/pick");
var ViewPortAdapter_1 = require("./ViewPortAdapter");
var useStateRef_1 = require("./useStateRef");
var id_1 = require("tsafe/id");
function useDomRect(params) {
    var _a;
    var internallyCreatedRef = (0, useStateRef_1.useStateRef)(null);
    var ref = (_a = params === null || params === void 0 ? void 0 : params.ref) !== null && _a !== void 0 ? _a : internallyCreatedRef;
    var _b = (0, useDomRect_1.useDomRect)({ ref: ref }), domRect = _b.domRect, checkIfDomRectUpdated = _b.checkIfDomRectUpdated;
    var zoomFactor = (function useClosure() {
        var viewPortState = (0, ViewPortAdapter_1.useViewPortState)().viewPortState;
        var zoomFactor = (viewPortState !== null && viewPortState !== void 0 ? viewPortState : {}).zoomFactor;
        return { zoomFactor: zoomFactor };
    })().zoomFactor;
    (0, react_1.useEffect)(function () { checkIfDomRectUpdated(); }, [zoomFactor !== null && zoomFactor !== void 0 ? zoomFactor : Object]);
    var fixedDomRect = (0, react_1.useMemo)(function () {
        var writableDomRect = (0, pick_1.pick)(domRect, useDomRect_1.domRectKeys);
        if (zoomFactor !== undefined) {
            useDomRect_1.domRectKeys.forEach(function (key) { return writableDomRect[key] /= zoomFactor; });
        }
        return (0, id_1.id)(writableDomRect);
    }, [domRect, zoomFactor !== null && zoomFactor !== void 0 ? zoomFactor : Object]);
    return { ref: ref, "domRect": fixedDomRect };
}
exports.useDomRect = useDomRect;
//# sourceMappingURL=useDomRect.js.map